import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './DemoUserBanner.css';

/**
 * A small, fixed banner shown at the very top of the viewport whenever
 * the logged-in user's category is "demo".
 *
 * Purpose: make it unambiguous to demo users that they are in a demo
 * environment so they do not enter sensitive data or expect persistence.
 */
const DemoUserBanner = () => {
  const { auth } = useAuth();
  const category = auth?.user?.category?.toLowerCase?.();

  // Render nothing for non-demo users or when category is missing
  if (category !== 'demo') return null;

  return (
    <div className="demo-ribbon"><span>Demo Environment</span></div>
  );
};

export default DemoUserBanner;
